import React, { useRef, useState } from 'react';

//Servicios
import { useGlobalContext } from '../../contexts/GlobalContext';

//Estilos
import './Signup.css';
import './SignUpMediaQueries.css';

//Componentes
import InputBadge from '../../components/inputBadge/InputBadge';
import { Controller } from 'react-hook-form';

function ProducerSignup({ functions, states }) {
    const { buildSelectOptions } = useGlobalContext();

    const {
        register,
        control,
        handleSubmit,
        watch,
        formState: { errors },
        onSubmit,
        onAddBadge,
        onBadgeDelete,
    } = functions;

    const { logged, nroViñedoArray } = states;

    const password = useRef({});
    password.current = watch('clave');

    return (
        <div className="signup-background">
            <div
                className={
                    logged
                        ? 'form-signup-card signup-form_logged'
                        : 'form-signup-card'
                }
            >
                <form className="signup-form" onSubmit={handleSubmit(onSubmit)}>
                    {!logged && (
                        <h4 className="signup-subtitle">Registro de Usuario</h4>
                    )}
                    {logged && (
                        <h3>
                            Su registro se ha realizado con éxito. Hemos enviado
                            instrucciones a su correo para continuar.
                        </h3>
                    )}
                    {!logged && (
                        <fieldset className="signup-fieldset">
                            <section className="signup-section">
                                <label className="label-signup">
                                    <div>
                                        <span>Nombre de Usuario: </span>
                                        <input
                                            className="signup-input"
                                            type="text"
                                            {...register('usuario', {
                                                required:
                                                    'Debe ingresar un nombre de usuario',
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    e.target.value.length > 20
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.usuario && (
                                        <small className="form__error">
                                            {errors.usuario?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Nombre: </span>
                                        <input
                                            className="signup-input"
                                            type="text"
                                            {...register('nombre', {
                                                required:
                                                    'Debe ingresar un nombre',
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    e.target.value.length > 30
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.nombre && (
                                        <small className="form__error">
                                            {errors.nombre?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Apellido: </span>
                                        <input
                                            className="signup-input"
                                            type="text"
                                            {...register('apellido', {
                                                required:
                                                    'Debe ingresar un apellido',
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    e.target.value.length > 30
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.apellido && (
                                        <small className="form__error">
                                            {errors.apellido?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Tipo Documento: </span>
                                        <select {...register('doc_id_tipo')}>
                                            {buildSelectOptions(
                                                'DocumentTypes'
                                            )?.map((op) => {
                                                return (
                                                    <option
                                                        key={op.name}
                                                        value={op.value}
                                                    >
                                                        {op.title}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Nro de Documento: </span>
                                        <input
                                            className="signup-input"
                                            type="text"
                                            {...register('doc_id', {
                                                required:
                                                    'Debe ingresar un documento de identidad',
                                                validate: {
                                                    minLength: (v) =>
                                                        v.length >= 8 ||
                                                        'El número de documento debe tener un mínimo de 8 caracteres',
                                                },
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    !/[A-Za-z0-9]+/.test(
                                                        e.key
                                                    ) ||
                                                    e.target.value.length > 15
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.doc_id && (
                                        <small className="form__error">
                                            {errors.doc_id?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Dirección: </span>
                                        <input
                                            className="signup-input"
                                            type="text"
                                            {...register('direccion', {
                                                required:
                                                    'Debe ingresar una dirección',
                                            })}
                                        />
                                    </div>
                                    {errors.direccion && (
                                        <small className="form__error">
                                            {errors.direccion?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Teléfono: </span>
                                        <input
                                            className="signup-input"
                                            type="tel"
                                            {...register('celular', {
                                                required:
                                                    'Debe ingresar un teléfono',
                                                pattern: {
                                                    value: /^[0-9]*$/,
                                                    message:
                                                        'Formato incorrecto',
                                                },
                                                minLength: {
                                                    value: 9,
                                                    message:
                                                        'El teléfono debe tener un mínimo de 9 caracteres',
                                                },
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    e.target.value.length > 20
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.celular && (
                                        <small className="form__error">
                                            {errors.celular?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Correo: </span>
                                        <input
                                            className="signup-input"
                                            type="email"
                                            {...register('correo', {
                                                required:
                                                    'Debe ingresar un correo',
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    e.target.value.length > 50
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.correo && (
                                        <small className="form__error">
                                            {errors.correo?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Clave: </span>
                                        <input
                                            className="signup-input"
                                            type="password"
                                            autoComplete="off"
                                            {...register('clave', {
                                                required:
                                                    'La clave es requerida',
                                                minLength: {
                                                    value: 8,
                                                    message:
                                                        'La clave debe tener un mínimo de 8 caracteres',
                                                },
                                                pattern: {
                                                    value: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&#-]/,
                                                    message:
                                                        'La clave debe tener al menos una minúscula, una mayúscula, un número y un caracter especial [@$-!%*?&#]',
                                                },
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    e.target.value.length > 20
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.clave && (
                                        <small className="form__error">
                                            {errors.clave?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Confirmar clave: </span>
                                        <input
                                            className="signup-input"
                                            type="password"
                                            autoComplete="off"
                                            {...register('confirmPassword', {
                                                required:
                                                    'Debe ingresar una clave de confirmación',
                                                validate: (value) =>
                                                    value ===
                                                        password.current ||
                                                    'Las claves no coinciden',
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    e.target.value.length > 20
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.confirmPassword && (
                                        <small className="form__error">
                                            {errors.confirmPassword?.message}
                                        </small>
                                    )}
                                </label>
                            </section>
                            <h4 className="signup-subtitle">Datos de Viñedo</h4>
                            <section className="signup-section">
                                <label className="label-signup">
                                    <div>
                                        <span>BPS: </span>
                                        <input
                                            className="signup-input"
                                            type="number"
                                            {...register('bps', {
                                                validate: {
                                                    length: (v) =>
                                                        v.length == 0 ||
                                                        (v.length >= 12 &&
                                                            v.length <= 15) ||
                                                        'El número de BPS debe tener entre 12 y 15 dígitos',
                                                },
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    !/[0-9]/.test(e.key) ||
                                                    e.target.value.length > 15
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.bps && (
                                        <small className="form__error">
                                            {errors.bps?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>RUT: </span>
                                        <input
                                            className="signup-input"
                                            type="number"
                                            {...register('rut', {
                                                validate: {
                                                    length: (v) =>
                                                        v.length == 0 ||
                                                        (v.length >= 12 &&
                                                            v.length <= 15) ||
                                                        'El número de RUT debe tener entre 12 y 15 dígitos',
                                                },
                                            })}
                                            onKeyPress={(e) => {
                                                if (
                                                    !/[0-9]/.test(e.key) ||
                                                    e.target.value.length > 15
                                                ) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </div>
                                    {errors.rut && (
                                        <small className="form__error">
                                            {errors.rut?.message}
                                        </small>
                                    )}
                                </label>
                                <label className="label-signup">
                                    <div>
                                        <span>Números de Viñedo: </span>
                                        <Controller
                                            name="nrosViñedos"
                                            control={control}
                                            rules={{
                                                validate: {
                                                    requiredVineyards: () =>
                                                        nroViñedoArray.length >
                                                            0 ||
                                                        'Debe ingresar al menos un número de viñedo',
                                                },
                                            }}
                                            render={() => (
                                                <InputBadge
                                                    type={'number'}
                                                    dataArray={nroViñedoArray}
                                                    onAdd={onAddBadge}
                                                    onDelete={onBadgeDelete}
                                                />
                                            )}
                                        />
                                    </div>
                                    {errors.nrosViñedos && (
                                        <small className="form__error">
                                            {errors.nrosViñedos.message}
                                        </small>
                                    )}
                                </label>
                            </section>
                            <button
                                className="btn btn-primary btn-signup"
                                type="submit"
                            >
                                Registrarse
                            </button>
                        </fieldset>
                    )}
                </form>
            </div>
        </div>
    );
}

export default ProducerSignup;
